"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendProfileResumeCheckbox = SendProfileResumeCheckbox;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
function SendProfileResumeCheckbox({ sendProfileAsResume, setSendProfileAsResume }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: "sendProfileResume", initialValue: sendProfileAsResume, valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(antd_1.Checkbox, { onChange: e => {
                    setSendProfileAsResume(e.target.checked);
                }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.profile_resume", values: {
                        Link: chunks => (0, jsx_runtime_1.jsx)(elements_1.Link, { to: "/ucet/profil", children: chunks }),
                    } }) }) }) }));
}
